export class ContentTypes {
  static readonly ContactUs = 'contact';
  static readonly Page = 'page';
  static readonly Help = 'help';
  static readonly Logo = 'logo';
  static readonly Footer = 'footer';
  static readonly Alert = 'alert';
  static readonly Hero = 'hero';
  static readonly Panel = 'panel';
  static readonly NotFound = 'notFound';
}
